import { SimpleWithFooter } from '../layouts/SimpleWithFooter';
import React from 'react';

export const ErrorPage = props => (
  <SimpleWithFooter>{props.children}</SimpleWithFooter>
);
